import { Box, IconButton, Tooltip, FormControlLabel, Switch } from '@mui/material';
import {
  Settings as SettingsIcon,
} from '@mui/icons-material';

const ToolbarControls = ({ 
  readOnly = false,
  onReadOnlyToggle,
  onOpenViewSettings,
}) => {
  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
      {onReadOnlyToggle != null && (
        <FormControlLabel
          control={
            <Switch
              size="small"
              checked={!!readOnly}
              onChange={(e) => { e.stopPropagation(); onReadOnlyToggle(e.target.checked); }}
              onClick={(e) => e.stopPropagation()}
              onMouseDown={(e) => e.stopPropagation()}
            />
          }
          label="Read-only"
          sx={{ ml: 0 }}
        />
      )}
      {onOpenViewSettings != null && (
        <Tooltip title="View settings">
          <IconButton size="small" onClick={(e) => { e.stopPropagation(); onOpenViewSettings(); }} sx={{ ml: 0.5 }}>
            <SettingsIcon fontSize="small" />
          </IconButton>
        </Tooltip>
      )}
    </Box>
  );
};

export default ToolbarControls;
